import { Navigate, Outlet, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "../context/AuthContext";
import { AccessDeniedPage } from "../pages/AccessDeniedPage";
import { AccountSetupPage } from "../pages/AccountSetupPage";

export function ProtectedRoute() {
  const { user, loading, isOrganizerOrAdmin, accountStatus } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (accountStatus === "no-access" || !isOrganizerOrAdmin) {
    return <AccessDeniedPage />;
  }

  if (accountStatus === "needs-setup") {
    return <AccountSetupPage />;
  }

  return <Outlet />;
}
